module.exports = require('graphology-canvas');